var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-divider',{attrs:{"color":"#F5F5F5"}}),_c('div',{staticClass:"mx-3 tp-text-label",class:_vm.textClass},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2),_c('v-divider',{attrs:{"color":"#F5F5F5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }